module.exports = __webpack_public_path__ + "img/doc.16512b36.svg";